import { useEffect, useRef, useState } from "react";
import { useRecoilState } from "recoil";
import { pubState } from "../../../recoil/pub.atom";
import { styled } from "styled-components";
import { Swiper, SwiperRef, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
const ThumbnailWrapper = styled.div`
  position: relative;
  width: 98%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 2px;
`;

const ImageView = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  overflow: hidden;
  position: relative;
  height: 370px;
  &::after {
    z-index: 2;
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 52.93%,
      rgba(0, 0, 0, 0.225597) 60.95%,
      #000000 88.48%
    );

    pointer-events: none;
  }
  .swiper {
    height: 100%;
  }

  img.content {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
const ArrowButton = styled.div<{
  direction: "left" | "right";
}>`
  cursor: pointer;
  width: 44px;
  height: 44px;
  position: absolute;
  border-radius: 22px;
  padding: 10px;
  top: 50%;
  ${(props) => (props.direction === "left" ? "left: 6px;" : "right: 6px;")}
  transform: translateY(-50%);
  text-align: right;

  img {
    width: 24px;
    height: 24px;
    object-fit: contain;
    ${(props) =>
      props.direction === "left" ? "transform: rotate(180deg);" : ""}
  }

  z-index: 11;
`;
const Indicator = styled.div`
  position: absolute;
  right: 16px;
  bottom: 24px;
  border-radius: 12px;
  padding: 4px 16px;
  color: var(--Black-200, rgba(183, 183, 183, 1));

  text-align: center;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  z-index: 20;
  background: rgba(255, 255, 255, 0.2);

  gap: 3px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  > .white {
    color: #fff;
    font-weight: 600;
  }
`;

const StoreInfoWrapper = styled.div`
  position: absolute;
  z-index: 2;
  bottom: 23px;
  left: 15px;
  width: 420px;
  height: 280px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 20px 16px 0;
  color: white;

  > .top {
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    > .title-box {
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      text-align: center;
      > .title {
        color: white;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        letter-spacing: -0.32px;
      }
    }

    > .tag {
      padding: 4px 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: 2px;

      > img {
        width: 16px;
        height: 16px;
        object-fit: contain;
      }

      color: white;
      font-family: Pretendard;
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      border-radius: 14px;
      background: linear-gradient(
        103.15deg,
        #6c36d6 -22.02%,
        #955fff 54.56%,
        #ccb2ff 102.58%
      );
    }

    > .tag.affiliate {
      border: 1.5px solid #f2f7ff;
      color: #176ced;
      font-family: Pretendard;
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      background: transparent;
    }

    > .tag.normal {
      border: 1.5px solid var(--Black-100, #f0f0f0);
      color: var(--Black-300, #808080);
      font-family: Pretendard;
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      background: transparent;
    }
  }

  > .title-wrapper {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 6px;

    > .address {
      color: white;
      font-family: Pretendard;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      letter-spacing: -0.28px;
    }
    > .info-row {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      gap: 4px;
      > .item {
        padding: 0 6px;
        height: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-family: Pretendard;
        font-size: 10px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        border-radius: 16.667px;
        background: rgba(100, 54, 231, 1);
      }
    }
  }

  > .count-wrapper {
    margin-top: 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;

    > .item {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      color: white;
      font-family: Pretendard;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      letter-spacing: -0.28px;

      > img {
        width: 16px;
        height: 16px;
      }
    }
  }
`;

const ManageMentPreviewImage = () => {
  const [pub] = useRecoilState(pubState);
  const mainSwiperRef = useRef<SwiperRef>();
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const [currentIndex, setCurrentIndex] = useState<number>(0);

  useEffect(() => {
    if (mainSwiperRef.current) {
      mainSwiperRef.current?.swiper.slideTo(selectedIndex);
    }
  }, [selectedIndex]);

  const getKoreanNumber = (targetNum: number) => {
    const koreanUnits = ["조", "억", "만", ""];
    const unit = 10000;
    let answer = "";

    while (targetNum > 0) {
      const mod = targetNum % unit;
      const modToString = mod.toString().replace(/(\d)(\d{3})/, "$1,$2");
      targetNum = Math.floor(targetNum / unit);
      const textUnit = koreanUnits.pop();
      if (textUnit === "만") {
        answer = `${modToString}${textUnit}`;
      } else {
        answer = `${modToString}${textUnit}${answer}`;
      }
    }
    if (answer === "") {
      answer = targetNum.toLocaleString();
    }
    return answer;
  };

  const getGameTypeString = (gameTypes: string[]) => {
    return gameTypes
      .map((type) => {
        if (type === "TOURNAMENT") {
          return "토너먼트";
        } else if (type === "OTHER_GAME") {
          return "기타게임";
        }
      })
      .join(", ");
  };

  return (
    <ThumbnailWrapper>
      <ImageView>
        <Swiper
          ref={mainSwiperRef}
          slidesPerView={"auto"}
          centeredSlides={true}
          spaceBetween={0}
          loop={true}
          autoplay={{ delay: 3000 }}
          modules={[Autoplay]}
          onRealIndexChange={(swiper: any) => setCurrentIndex(swiper.realIndex)}
        >
          {pub?.images.map((url, index) => (
            <SwiperSlide key={index}>
              <img
                alt="메인"
                className="content"
                src={
                  pub?.images[index]
                    ? pub?.images[index].imageUrl
                    : "https://dfesoodpx4jgd.cloudfront.net/cafe/default.png"
                }
              />
            </SwiperSlide>
          ))}
        </Swiper>
        <ArrowButton
          direction="left"
          onClick={() => {
            setSelectedIndex(
              pub?.images?.length
                ? (selectedIndex - 1 + pub?.images.length) % pub?.images.length
                : 0,
            );
          }}
        >
          <img alt="left" src="/image-web/management/arrow-right.svg" />
        </ArrowButton>
        <ArrowButton
          direction="right"
          onClick={() => {
            setSelectedIndex(
              pub?.images.length ? (selectedIndex + 1) % pub?.images.length : 0,
            );
          }}
        >
          <img alt="right" src="/image-web/management/arrow-right.svg" />
        </ArrowButton>
        <Indicator>
          <span className="white">{currentIndex + 1}</span>
          <span>/</span>
          <span>{pub?.images.length}</span>
        </Indicator>
      </ImageView>
      <StoreInfoWrapper>
        <div className="top">
          <div className="title-box">
            <div className="title">{pub?.cafeName}</div>
          </div>
          <div className="tag">
            <img src="/image-web/management/premium_badge.svg" alt="badge" />
            프리미엄
          </div>
        </div>
        <div className="title-wrapper">
          <div className="address">
            {pub?.newAddress} {pub?.detailAddress}
          </div>
          <div className="info-row">
            <div className="item">
              {pub?.gameTypes && getGameTypeString(pub.gameTypes)}
            </div>
            {pub?.buyIn && (
              <div className="item">
                바이인 : {getKoreanNumber(pub?.buyIn ?? 0)} ~{" "}
                {pub?.buyInMax ? getKoreanNumber(pub?.buyInMax ?? 0) : ""}
              </div>
            )}
          </div>
        </div>
        <div className="count-wrapper">
          <div className="item">
            <img
              src="/image-web/management/heart-small-white.svg"
              alt="heart"
            />
            0
          </div>
          <div className="item">
            <img src="/image-web/management/map-small-white.svg" alt="map" />0
            km
          </div>
        </div>
      </StoreInfoWrapper>
    </ThumbnailWrapper>
  );
};
export default ManageMentPreviewImage;
